import { TEMPLATES } from '../lib/templates';
import { useStore } from '../store/useStore';
import { useDocControllerContext } from '../hooks/DocControllerContext';
import { useT } from '../i18n/useT';
import { Modal } from './Modal';

/** Pick a built-in template to start a new document from. */
export function TemplateDialog() {
  const t = useT();
  const controller = useDocControllerContext();
  const open = useStore((s) => s.templatesOpen);
  const setOpen = useStore((s) => s.setTemplatesOpen);

  if (!open) return null;
  const close = () => setOpen(false);

  return (
    <Modal onClose={close} title={t('tpl.title')}>
      <p className="mb-modal-note">{t('tpl.note')}</p>
      <ul className="mb-template-list">
        {TEMPLATES.map((tpl) => (
          <li key={tpl.id}>
            <button
              className="mb-template-item"
              onClick={() => {
                close();
                void controller.createFrom(tpl.content());
              }}
            >
              {t(tpl.nameKey)}
            </button>
          </li>
        ))}
      </ul>
      <div className="mb-modal-actions">
        <button className="mb-btn" onClick={close}>
          {t('common.cancel')}
        </button>
      </div>
    </Modal>
  );
}
